<template>
  <v-container :class="{'fill-height': !hasMessage}">
    <v-row align="center"
           justify="center">
      <v-col cols="12"
             sm="8"
             md="6">
        <v-form @submit.prevent="submit"
                :disabled="form.busy"
                autocomplete="on"
                ref="form">
          <v-card tile
                  class="mb-4">
            <v-card-title class="d-flex flex-column text-uppercase align-center justify-center">
              <v-img src="/v2/images/mobilelocker_logo.png"
                     alt="Mobile Locker">
              </v-img>
              Sign In
            </v-card-title>
            <v-progress-linear indeterminate
                               v-if="form.busy">
            </v-progress-linear>
            <v-card-text class="pb-0">

              <v-text-field v-model="form.email"
                            type="email"
                            placeholder="Your email address"
                            autocomplete="username"
                            :disabled="form.busy"
                            @keydown="emailEntered = false"
                            :rules="[rules.required, rules.email]"
                            :error-messages="form.errors.get('email')">
              </v-text-field>

              <template v-if="emailEntered">
                <p v-if="ssoRequired"
                   class="text-center">
                  <v-icon left>
                    fal fa-lock
                  </v-icon>
                  Single sign-on is required for {{ domain }}
                </p>

                <template v-else>
                  <v-text-field v-model="form.password"
                                type="password"
                                placeholder="Your password"
                                autocomplete="current-password"
                                :disabled="form.busy"
                                :hide-details="!form.errors.has('password')"
                                :rules="[rules.required]"
                                :error-messages="form.errors.get('password')">
                    <template v-if="1===2"
                              v-slot:append>
                      <router-link :to="{name: 'password.request'}"
                                   class="text-caption">
                        Forgot?
                      </router-link>
                    </template>
                  </v-text-field>

                  <v-checkbox v-model="form.remember"
                              label="Remember me"
                              hide-details>
                  </v-checkbox>
                </template>
              </template>

              <div v-if="error"
                   class="red--text">
                {{ error }}
              </div>
            </v-card-text>
            <v-card-actions class="justify-space-between">
              <v-btn v-if="!emailEntered"
                     @click.prevent="checkEmail"
                     :disabled="form.busy"
                     block
                     color="primary"
                     class="mb-4">
                Continue
              </v-btn>

              <template v-else>
                <v-btn v-if="ssoRequired"
                       type="submit"
                       :disabled="form.busy"
                       block
                       color="primary">
                  Redirecting
                </v-btn>
                <v-btn v-else
                       type="submit"
                       :disabled="form.busy"
                       block
                       color="primary">
                  Log in
                </v-btn>
              </template>

              <!--<v-btn :to="{name: 'password.request'}"
                     text>
                Forgot password?
              </v-btn>-->
            </v-card-actions>
            <v-card-text class="py-2 d-flex justify-center">
              <router-link :to="{name: 'password.request'}">
                Forgot your password?
              </router-link>
            </v-card-text>
          </v-card>
        </v-form>

        <v-alert v-if="ssoErrorMessage"
                 type="error"
                 tile>
          <div class="font-weight-bold">
            SSO Error
          </div>
          <template v-if="ssoErrorCode">
            Error Message: {{ ssoErrorMessage }}<br/>
            Error code: <strong>{{ ssoErrorCode }}</strong>
          </template>
          <template v-else>
            {{ ssoErrorMessage }}
          </template>
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import formValidation from '../../plugins/formValidation';
import DynamicsDialog from './components/DynamicsDialog';

export default {
  components: {DynamicsDialog},
  mixins: [formValidation],
  metaInfo() {
    this.$store.commit('setTitle', `Log in`);
    return {
      title: this.$store.getters.title,
    }
  },
  data() {
    return {
      error: null,
      ssoErrorCode: null,
      ssoErrorMessage: null,
      form: new Form({
        email: '',
        password: '',
        remember: true,
        v2: true,
      }),
      emailEntered: false,
      checkDomainComplete: false, // MLD-2557
      ssoRequired: false, // MLD-2557
    }
  },
  computed: {
    ...mapGetters([
      'authenticated',
      'isAdmin',
      'user',
    ]),
    ...mapGetters('botDetector', [
      'isBot',
    ]),
    hasMessage() {
      return !!this.message;
    },
  },
  created() {
    this.checkErrors();
    this.initLogin();
  },
  methods: {
    checkErrors() {
      if (this.$route.query.error_code) {
        this.ssoErrorCode = this.$route.query.error_code;
      } else {
        this.ssoErrorCode = null;
      }
      if (this.$route.query.error_message) {
        this.ssoErrorMessage = this.$route.query.error_message;
      } else {
        this.ssoErrorMessage = null;
      }
    },
    checkEmail() {
      this.form.busy = true;
      return this.checkDomain()
        .catch(() => {
        })
        .finally(() => {
          this.emailEntered = true;
          this.form.busy = false;
        })
    },
    async checkDomain() { // MLD-2557
      /*if (this.isBot) { // MLD-5093
        console.log('Bots are not allowed.');
        this.$toast.error('Bots are not allowed.');
        return Promise.reject(new Error('Bots are not allowed.'));
      }*/
      try {
        grecaptcha.ready(async () => {
          this.form.busy = true;
          const recaptchaToken = await grecaptcha.execute(window.recaptcha_site_key, {action: 'check_domain'});
          const form = {
            recaptcha_token: recaptchaToken,
            email: this.form.email,
            source: 'browser', // MLD-5840
          }
          return axios.get(`/api/team-domains/check`, {params: form})
            .then(response => {
              this.checkDomainComplete = response.data.complete;
              this.domain = response.data.domain_name;
              this.ssoRequired = response.data.requires_sso;
              if (this.ssoRequired) {
                this.redirectToSSOProvider();
              } else {
                this.form.busy = false;
              }
            })
            .catch(() => {
              this.checkDomainComplete = false;
              this.ssoRequired = false;
              this.form.busy = false;
            });
        });
      } catch (e) {
        console.log('Google Recaptcha exception', e);
      }
    },
    initLogin() {
      this.$store.commit('LOGOUT');

      //axios.get('/spark/token').catch(() => {});
    },
    async submit() {
      /*if (this.isBot) { // MLD-5093
        console.log('Bots are not allowed.');
        return;
      }*/
      if (this.form.busy) {
        return;
      }
      if (!this.emailEntered) {
        this.checkEmail()
          .finally(() => {
            //this.form.busy = false;
          })
        return;
      }
      this.error = null;
      this.form.busy = true;
      await this.checkDomain();

      if (this.ssoRequired) {
        this.redirectToSSOProvider();
      } else {
        try {
          const {data, status} = await this.form.post(`/login`)
          this.form.busy = true;

          if (data && data.redirect_to) {
            window.location.assign(data.redirect_to);
          } else {
            window.location.assign('/v2/app/content');
          }
        } catch (err) {
          console.log('Swallowing the login authentication error', err.response ? err.response.data : null);
        }
      }
      //window.location.assign('/v2/login/redirect');
    },
    redirectToSSOProvider() {
      this.form.busy = true;
      const url = `/login/workos/auth?email=${this.form.email}`;
      setTimeout(() => {
        window.location.assign(url);
      }, 1000)
    }
  }
}
</script>
